import { useMutation, useQueryClient } from "@tanstack/react-query";

import { cancelJob } from "../../../services/backgroundJobs";

const QUERY_KEY = ["background-jobs"] as const;

interface UseCancelJobParams {
  tenantId: string;
}

export const useCancelBackgroundJob = ({ tenantId }: UseCancelJobParams) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (jobId: string) => cancelJob(jobId, tenantId),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: QUERY_KEY }),
        queryClient.invalidateQueries({
          predicate: (query) => {
            const root = query.queryKey[0];
            return typeof root === "string" && root.startsWith("coaching-artifacts");
          }
        })
      ]);
    }
  });
};
